export default __webpack_public_path__ + "static/media/cat-badge-selected.b3dc14ab.svg";